const cards = [
  {
    id: 1,
    title: '某影帝深夜被拍与神秘女子同行，街头亲密互动引猜测',
    excerpt: '近日有媒体拍到知名影帝深夜与一名年轻女性在北京三里屯附近同行，两人举止亲密。该影帝此前一直以单身人设示人，此次曝光引发网友热议...',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20city%20street%20at%20night%20with%20warm%20streetlights%2C%20luxury%20cars%20in%20background%2C%20paparazzi%20style%20photography%2C%20mysterious%20urban%20atmosphere%2C%20no%20people%2C%20cinematic%20mood&width=700&height=450&seq=card-1&orientation=landscape',
    tag: '独家',
    time: '5小时前',
    views: '23.8万',
  },
  {
    id: 2,
    title: '综艺节目导演组内部邮件流出：淘汰名单早已内定',
    excerpt: '一份标注为"内部机密"的节目组邮件在社交平台疯传，邮件中详细列出了未来三期节目的淘汰顺序和复活人选，与节目宣传的"全民投票"规则完全不符...',
    image: 'https://readdy.ai/api/search-image?query=A%20printed%20confidential%20document%20on%20a%20dark%20desk%2C%20dramatic%20warm%20lighting%2C%20official%20letterhead%20style%2C%20mysterious%20investigative%20mood%2C%20no%20text%2C%20professional%20photography&width=700&height=450&seq=card-2&orientation=landscape',
    tag: '爆料',
    time: '8小时前',
    views: '45.2万',
  },
  {
    id: 3,
    title: '网红直播带货翻车，产品被检测出含有违禁成分',
    excerpt: '某千万粉丝量级带货主播近日陷入产品质量丑闻，其直播间推荐的一款护肤品经第三方检测机构鉴定含有处方药成分，目前已有消费者发起集体维权...',
    image: 'https://readdy.ai/api/search-image?query=A%20laboratory%20testing%20scene%20with%20cosmetic%20products%20and%20test%20tubes%2C%20warm%20dramatic%20lighting%2C%20scientific%20aesthetic%2C%20dark%20background%2C%20no%20people%2C%20serious%20investigative%20mood&width=700&height=450&seq=card-3&orientation=landscape',
    tag: '重磅',
    time: '11小时前',
    views: '67.5万',
  },
  {
    id: 4,
    title: '某女团成员被爆私下霸凌队友，多段录音证据浮出水面',
    excerpt: '一位自称已退团的前女团成员在个人社交账号上发布了多段录音，内容疑似涉及队内长期存在的霸凌行为。所属经纪公司紧急发表声明称将"积极沟通"...',
    image: 'https://readdy.ai/api/search-image?query=A%20darkened%20rehearsal%20studio%20with%20mirrors%20and%20dance%20floor%2C%20dramatic%20red%20spotlight%2C%20empty%20space%2C%20mysterious%20atmosphere%2C%20kpop%20training%20room%20aesthetic%2C%20no%20people&width=700&height=450&seq=card-4&orientation=landscape',
    tag: '深扒',
    time: '14小时前',
    views: '89.1万',
  },
  {
    id: 5,
    title: '知名作家被指控作品代笔，出版社紧急下架所有书籍',
    excerpt: '网上突然出现大量指控某畅销作家实际由团队代笔的证据，包括合同文件、银行转账记录和原始手稿对比图。目前各大电商平台已将该作家作品全部下架...',
    image: 'https://readdy.ai/api/search-image?query=A%20stack%20of%20books%20and%20manuscripts%20on%20a%20dark%20wooden%20desk%2C%20dramatic%20warm%20lamp%20lighting%2C%20literary%20investigation%20mood%2C%20mysterious%20atmosphere%2C%20no%20people&width=700&height=450&seq=card-5&orientation=landscape',
    tag: '独家',
    time: '16小时前',
    views: '34.7万',
  },
  {
    id: 6,
    title: '体育明星婚内出轨聊天记录被曝光，品牌方纷纷解约',
    excerpt: '一份内容劲爆的聊天记录截图在体育圈粉丝群中快速传播，涉事运动员的多个赞助品牌已在24小时内宣布终止合作，其个人社交账号也已设为私密...',
    image: 'https://readdy.ai/api/search-image?query=A%20luxury%20hotel%20room%20with%20dim%20warm%20lighting%2C%20empty%20bed%2C%20scandal%20aesthetic%2C%20mysterious%20mood%2C%20elegant%20interior%2C%20no%20people%2C%20cinematic%20style&width=700&height=450&seq=card-6&orientation=landscape',
    tag: '劲爆',
    time: '20小时前',
    views: '156万',
  },
  {
    id: 7,
    title: '娱乐圈"阴阳合同"再度浮出水面，税务部门已介入调查',
    excerpt: '一封匿名举报信近日被提交至税务稽查部门，信中附带了多位知名艺人涉嫌通过"阴阳合同"方式偷逃税款的详细材料，涉案金额据传高达数亿元...',
    image: 'https://readdy.ai/api/search-image?query=%20stack%20of%20legal%20contracts%20and%20bank%20statements%20on%20a%20dark%20desk%2C%20dramatic%20warm%20lighting%2C%20financial%20investigation%20mood%2C%20official%20document%20aesthetic%2C%20no%20people%2C%20serious%20atmosphere&width=700&height=450&seq=card-7&orientation=landscape',
    tag: '重磅',
    time: '1天前',
    views: '198万',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="section-anchor py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">热点事件追踪</h2>
          <p className="text-sm text-foreground-500 max-w-[600px] mx-auto">911吃瓜事件完整专题，每一条爆料都有据可查</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {cards.slice(0, 4).map((item) => (
            <div key={item.id} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer">
              <div className="aspect-[4/3] overflow-hidden">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className={`px-1.5 py-0.5 rounded text-xs font-semibold ${
                    item.tag === '独家' ? 'bg-accent-100 text-accent-800' :
                    item.tag === '重磅' || item.tag === '劲爆' ? 'bg-primary-100 text-primary-700' :
                    'bg-secondary-100 text-secondary-700'
                  }`}>{item.tag}</span>
                  <span className="text-xs text-foreground-500">{item.time}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-3">{item.excerpt}</p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{item.views}</span>
                  <span className="flex items-center gap-1"><i className="ri-chat-3-line"></i>讨论</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mt-5">
          {cards.slice(4, 7).map((item) => (
            <div key={item.id} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer">
              <div className="aspect-[4/3] overflow-hidden">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className={`px-1.5 py-0.5 rounded text-xs font-semibold ${
                    item.tag === '重磅' || item.tag === '劲爆' ? 'bg-primary-100 text-primary-700' :
                    item.tag === '独家' ? 'bg-accent-100 text-accent-800' :
                    'bg-secondary-100 text-secondary-700'
                  }`}>{item.tag}</span>
                  <span className="text-xs text-foreground-500">{item.time}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-3">{item.excerpt}</p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{item.views}</span>
                  <span className="flex items-center gap-1"><i className="ri-chat-3-line"></i>讨论</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}